import { render, staticRenderFns } from "./auth-button.vue?vue&type=template&id=646f1a25&"
import script from "./auth-button.vue?vue&type=script&lang=js&"
export * from "./auth-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports